import { render, staticRenderFns } from "./PeopleTable.vue?vue&type=template&id=7ed98ade"
import script from "./PeopleTable.vue?vue&type=script&lang=js"
export * from "./PeopleTable.vue?vue&type=script&lang=js"
import style0 from "./PeopleTable.vue?vue&type=style&index=0&id=7ed98ade&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports